<template>
  <div id="app">
    <loading :isShow="showOrNot" @nextPage="onNextPage" />
    <!-- <page-kv :isShow="showOrNot" @nextPage="onNextPage" />
    <page-one :isShow="showOrNot" @nextPage="onNextPage" />
    <page-two :isShow="showOrNot" @nextPage="onNextPage" />
    <music-player /> -->
    <long-image :isShow="showOrNot" />
    <wx-share :shareTitle="title" :shareDesc="desc" :shareImg="thumbImg" :shareLink="link" />
    <!-- <rotate-it /> -->
  </div>
</template>

<script>
import Rotate from './components/rotate/Rotate'
import MusicPlayer from './components/musicPlayer/music-player'
import Loading from './pages/loading/loading'
import PageKV from './pages/page-kv/pageKV'
import PageOne from './pages/page-one/pageOne'
import PageTwo from './pages/page-two/pageTwo'
import WxShare from './components/wxShare/wxShare';
import LongImage from './components/longImage/longImage';

export default {
  name: 'app',
  components: {
    Loading,
    'rotate-it': Rotate,
    'music-player': MusicPlayer,
    'page-one': PageOne,
    'page-two': PageTwo,
    'page-kv': PageKV,
    'wx-share': WxShare,
    'long-image': LongImage
  },
  data () {
    return {
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPTShow: false,
      },
      title: '神秘小五的一天',
      desc: '来H5案例分享，找寻你的创意初心',
      thumbImg: 'https://www.jiandoukeji.com/h5/2019/a-day-of-x5/common/thumb.jpg',
      link: 'https://www.jiandoukeji.com/h5/2019/a-day-of-x5'
    }
  },
  methods: {
    onNextPage(para) {
      Object.keys(this.showOrNot).map(item => {
        this.showOrNot[item] = false
      })
      this.showOrNot[para] = true;
    }
  }
}
</script>

<style>
@import './assets/reset.less';
#app {
  position: fixed;
  width: 100%;
  height: 100%;
  /* min-width: 320px;
  max-width: 540px; */
}

canvas {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
